import {AutogenLayoutSurveyDetail} from "./autogen/AutogenLayoutSurveyDetail";
import {BlurEvent, ClickEvent, DataDisplayEvent} from "@mcleod/components";
import {StringUtil} from "@mcleod/core";

import {formatSqlQuery, testSqlQuery} from "./utils/SqlTestUtils";

export class SurveyDetail extends AutogenLayoutSurveyDetail {


    async buttonTestSQLOnClick(event: ClickEvent) {
        const sqlQuery = this.textboxSqlQuery.text;
        if (StringUtil.isEmptyString(sqlQuery)) {
            return;
        }
        const id = this.mainDataSource.data[0]?.get("id") as string;
        await testSqlQuery(this, id, sqlQuery);
    }

    textboxSqlQueryOnBlur(event: BlurEvent) {
        this.setTestSqlQueryButtonEnabled();
        formatSqlQuery(this.textboxSqlQuery.text);
    }

    textboxSqlQueryOnDataDisplay(event: DataDisplayEvent) {
        this.setTestSqlQueryButtonEnabled();
    }

    private setTestSqlQueryButtonEnabled() {
        this.buttonTestSQL.enabled = !StringUtil.isEmptyString(this.textboxSqlQuery.text);
        if (!this.buttonTestSQL.enabled) {
            this.labelQueryStatus.visible = false;
            this.buttonTestSQL.tooltip = "Enter a SQL Query";
        } else {
            this.buttonTestSQL.tooltip = "Run query count";
        }
    }

}
